import { render, staticRenderFns } from "./SalesTeamMembers.vue?vue&type=template&id=08a24584&scoped=true"
import script from "./SalesTeamMembers.vue?vue&type=script&lang=js"
export * from "./SalesTeamMembers.vue?vue&type=script&lang=js"
import style0 from "./SalesTeamMembers.vue?vue&type=style&index=0&id=08a24584&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a24584",
  null
  
)

export default component.exports